export function generateRandomGradient(index) {
  const gradients = [
    `conic-gradient(from 225.95deg at 50% 50%, #9b51e0 0deg, #542c7a 360deg)`,
    `conic-gradient(from 225.95deg at 50% 50%, #309bbc 0deg, #90bbca 360deg)`,
    `conic-gradient(from 225.95deg at 50% 50%, #30bc86 0deg, #90cab9 360deg)`,
    `conic-gradient(from 225.95deg at 50% 50%, #bc30a5 0deg, #ca90b6 360deg)`,
    `conic-gradient(from 225.95deg at 50% 50%, #bc3030 0deg, #ca9090 360deg)`,
  ];
  return gradients[index % gradients.length];
}

export function generateOrganizationsRandomGradient(index) {
  const gradients = [
    `conic-gradient(
    from 207.73deg at 97.58% 4.05%,
    #9730bc 0deg,
    #a960c3 178.2deg,
    #b98cc9 243deg,
    #ab66c4 253.8deg,
    #bb90ca 360deg
  )`,
    `conic-gradient(
    from 207.73deg at 97.58% 4.05%,
    #309bbc 0deg,
    #609dc3 178.2deg,
    #8cb2c9 243deg,
    #669ac4 253.8deg,
    #90bbca 360deg
  )`,
    `conic-gradient(
    from 207.73deg at 97.58% 4.05%,
    #30bc86 0deg,
    #60c39d 178.2deg,
    #8cc9ae 243deg,
    #66c4a0 253.8deg,
    #90cab9 360deg
  )`,
    `conic-gradient(
    from 207.73deg at 97.58% 4.05%,
    #bc30a5 0deg,
    #c360a4 178.2deg,
    #c98cb8 243deg,
    #c466a9 253.8deg,
    #ca90b6 360deg
  )`,
    `conic-gradient(
    from 207.73deg at 97.58% 4.05%,
    #bc3030 0deg,
    #c36060 178.2deg,
    #c98c8c 243deg,
    #c46666 253.8deg,
    #ca9090 360deg
  )`,
  ];
  return gradients[index % gradients.length];
}
